
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './convenios2pssf.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pconvenios2pssf = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6965bfef8e5aed52dc8e1832" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
        <a
          target=""
          className=""
          id="iumht8"
          href="/"
        >
          
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
        </a>
        
      <div id="itmdc" className="">
      
        <a
          target=""
          className="link-menu "
          id="iijdu7"
          href="/sobrenosotros"
        >
          
    <div id="inoik6" className="">
    <>Quienes Somos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijau3l"
          href="/proyectos"
        >
          
    <div id="i1h6oa" className="">
    <>Proyectos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iaxjnt"
          href="/campanas"
        >
          
    <div id="i2354t" className="">
    <>Campañas</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="imshx9"
          href="/impacto"
        >
          
    <div id="itxxvc" className="">
    <>Impacto Social</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="inca76"
          href="/impacto"
        >
          
    <div id="i8lzc3" className="">
    <>Convenios</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ibkqkk"
          href="/transparencia"
        >
          
    <div id="i8wosb" className="">
    <>Transparencia</>
    </div>
    
        </a>
        
      </div>
      
        <a
          target=""
          className="boton-primario "
          id="iiit99"
          href="/contacto"
        >
          
    <div id="i1fieg" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/proyectos"
        type=""
      >
        <>Proyectos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/campañas"
        type=""
      >
        <>Campañas</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/impacto"
        type=""
      >
        <>Impacto social</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/convenios"
        type=""
      >
        <>Convenios</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/transparencia"
        type=""
      >
        <>Transparencia</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ingwtg">
        <>Convenios</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div className="" id="i83s7t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i2uc23">
        <>Construimos alianzas que transforman vidas</>
      </span>
      
      </div>
      
      <div className="" id="ipqtra">
        <>A través de convenios estratégicos con empresas, organizaciones e instituciones, impulsamos proyectos de impacto social que generan oportunidades, fortalecen comunidades y promueven un desarrollo sostenible.</>
      </div>
      
      </div>
      
      <div id="iv262g" className="">
      
      <div id="i13q5u" className="">
      
      <div className="" id="iai5sb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9ivcq">
        <>Convenio FUNP-2022-2303BOG-HN (Tienda Café de la Paz) TENcPAZ</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ifxsi5" className="">
      
      <div id="ils44a" className="tarjeta-persona ">
      
      <div id="itogfa" className="">
      
      <img
        className=""
        id="ival2d"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirp1a9h.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iktbdc" className="">
      
      <div id="ibp6u7" className="">
      
      <div className="" id="i0cqn6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="idg96k">
        <>Convenio FUNP-2023-0601-GOBHN (Asociación de Desarrollo Educativo) ASODEH</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ifnkex" className="">
      
      <div id="il0m0c" className="tarjeta-persona ">
      
      <div id="i7hryi" className="">
      
      <img
        className=""
        id="ihnmde"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirp1xwl.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ifns3i" className="">
      
      <div id="imh1o6" className="">
      
      <div className="" id="isg826">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="irbvld">
        <>Convenio FUNP-2025-1008-RDHN (Petrus Republica Dominicana)</>
      </span>
      
      </div>
      
      </div>
      
      <div id="i82df2" className="">
      
      <div id="im95hk" className="tarjeta-persona ">
      
      <div id="i2k9lf" className="">
      
      <img
        className=""
        id="iv7gzi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirkrtbg.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="icvuhe">
        <>Fundación Petrus</>
      </span>
      
      </div>
      
      <img
        className=""
        id="inbg6e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="invc11" className="">
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Páginas</>
      </div>
      
      <div className="" id="igdgp1">
        <>Quienes Somos</>
      </div>
      
      <div className="" id="io8u0g">
        <>Proyectos</>
      </div>
      
      <div className="" id="ifh4ms">
        <>Impacto Social</>
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Más información</>
      </div>
      
      <div className="" id="il1rnw">
        <>Contacto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pconvenios2pssf);
  